const config = {
  initiateLoginEndpoint: process.env.REACT_APP_START_LOGIN_PAGE_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  backendClientId: process.env.REACT_APP_BACKEND_CLIENT_ID,
  infoboardBackendUrl: process.env.REACT_APP_INFOBOARD_API_URL,
  teamsAppId: process.env.REACT_APP_TEAMS_APP_ID,
  tenantOptimizerClientId: process.env.REACT_APP_TENANT_OPTIMIZER_CLIENT_ID,
  tenantOptimizerBackendUrl: process.env.REACT_APP_TENANT_OPTIMIZER_API_URL,
  migrationReportsClientId: process.env.REACT_APP_MIGRATION_REPORTS_CLIENT_ID,
  migrationReportsBackendUrl: process.env.REACT_APP_MIGRATION_REPORTS_API_URL,
  zohoBackendUrl: process.env.REACT_APP_ZOHO_API_URL,
};

export default config;
